import React from "react";
import { Box, FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import CategoryIcon from "@material-ui/icons/Category";
import PaletteIcon from "@material-ui/icons/Palette";
import ErEditAccordion from "./ErEditAccordion";
import TextEffectPicker from "./TextEffectPicker";
import ShapeColorPicker from "./ShapeColorPicker";
import { DraftIntTextField } from "./escapeRoomEditorFloatingWidgets";
import { pickEffectBundle, mergeEffectBundlePatch } from "./textEffectStyles";
import { SHAPE_TYPES } from "./escapeRoomEditorUiConstants";

export function ShapeElementContentPanel({ selectedElement, effectiveUpdateElement }) {
	const content = selectedElement.content || {};
	return (
		<ErEditAccordion title="Tipo de forma" icon={CategoryIcon} defaultOpen>
			<FormControl size="small" fullWidth variant="outlined">
				<InputLabel>Tipo</InputLabel>
				<Select
					value={content.shapeType || "square"}
					onChange={(e) => effectiveUpdateElement({ ...selectedElement, content: { ...content, shapeType: e.target.value } })}
					label="Tipo"
				>
					{SHAPE_TYPES.map((s) => (
						<MenuItem key={s.value} value={s.value}>{s.label}</MenuItem>
					))}
				</Select>
			</FormControl>
		</ErEditAccordion>
	);
}

export function ShapeElementStylePanel({ selectedElement, effectiveUpdateElement }) {
	const content = selectedElement.content || {};
	const style = selectedElement.style || {};
	const shapeType = content.shapeType || "square";

	return (
		<ErEditAccordion title="Estilo de la forma" icon={PaletteIcon} defaultOpen>
			<ErEditAccordion title="Colores y borde" nested defaultOpen>
				<Box mb={1.5}>
					<ShapeColorPicker label="Relleno" value={content.fillColor}
						onChange={(color) => effectiveUpdateElement({ ...selectedElement, content: { ...content, fillColor: color } })} />
				</Box>
				<Box mb={1.5}>
					<ShapeColorPicker label="Borde" value={content.strokeColor}
						onChange={(color) => effectiveUpdateElement({ ...selectedElement, content: { ...content, strokeColor: color } })} />
				</Box>
				<Box display="flex" style={{ gap: 10 }}>
					<DraftIntTextField label="Grosor borde" min={0} max={20} value={content.strokeWidth ?? 2}
						onCommit={(n) => effectiveUpdateElement({ ...selectedElement, content: { ...content, strokeWidth: n } })}
						style={{ flex: 1 }} variant="outlined" />
					{(shapeType === "square" || shapeType === "line" || shapeType === "triangle") && (
						<DraftIntTextField label="Redondeo" min={0} max={200} value={content.borderRadius ?? 0}
							onCommit={(n) => effectiveUpdateElement({ ...selectedElement, content: { ...content, borderRadius: n } })}
							style={{ flex: 1 }} variant="outlined" />
					)}
				</Box>
			</ErEditAccordion>

			<ErEditAccordion title="Efecto visual" nested>
				<TextEffectPicker
					effectStyle={pickEffectBundle(style, "text")}
					fallbackColor={content.strokeColor}
					onEffectStyleChange={(patch) =>
						effectiveUpdateElement({
							...selectedElement,
							style: mergeEffectBundlePatch(style, "text", patch),
						})
					}
				/>
			</ErEditAccordion>
		</ErEditAccordion>
	);
}
